import { useEffect } from "react";
import HeaderWeeklyReport from "../../../../Components/ComponentsIndustry/HeaderWeeklyReport";
import Loading from "../../../../Components/Loading";
import { useReportWeeklyIndustry } from "../../../../providers/ReportWeeklyIndustry";
import { useUser } from "../../../../providers/UserContext";
import {
  Container,
  SizeContainer,
  RoundContainer,
  H2RoundContainer,
  ParagraphRoundContainer,
  MainRoundContainer,
} from "./style";

const WeeklyReportPcp = () => {
  const { industry, jogo } = useUser()
  const { reportWeeklyIndustry, loading, fetchReportWeeklyIndustry, setReportWeeklyIndustry } = useReportWeeklyIndustry()

  useEffect(() => {
    setReportWeeklyIndustry({
      purchases: [],
      pcp: [],
      productions: [],
      salesInProgress: [],
      salesDone: []
    })
    if (!industry || !jogo) return
    fetchReportWeeklyIndustry()
  }, [industry, jogo])
  return (
    <Container>
      <SizeContainer>
        <HeaderWeeklyReport selected={["selection", "", "", ""]} />
        {loading ? (
          <RoundContainer>
            <Loading />
          </RoundContainer>

        ) : reportWeeklyIndustry?.pcp.length === 0 ? (
          <RoundContainer style={{ justifyContent: 'center' }}>
            <p style={{ fontSize: 20, fontWeight: 'bold' }}>Nenhum PCP enviado.</p>
          </RoundContainer>
        ) : null
        }
        {reportWeeklyIndustry?.pcp?.map((itemPcp, index) => {
          return (
            <RoundContainer key={index}>
              <H2RoundContainer>
                RODADA {itemPcp[0]?.rodada?.numero}
                <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
              </H2RoundContainer>
              <ParagraphRoundContainer>
                PCP Produtos
                <img src="./images/pcp_button.svg" alt="pcp_button" />
              </ParagraphRoundContainer>
              <MainRoundContainer>
                {itemPcp?.map((pcpProduct, index) => {
                  let imageURL = null
                  if (pcpProduct?.produto.nome === "Peito de Frango") {
                    imageURL = "./images/chicken_pcp.svg"
                  } else if (pcpProduct?.produto?.nome === "Coxa de Frango") {
                    imageURL = "./images/cut_chicken_pcp.svg"
                  } else if (pcpProduct?.produto?.nome === "Linguiça Salsichão") {
                    imageURL = "./images/pig.svg"
                  } else if (pcpProduct?.produto?.nome === "Batata Frita") {
                    imageURL = "./images/fries_pcp.svg"
                  }

                  return (
                    <p key={index} style={{ padding: 5 }}>
                      <img src={imageURL} />
                      Quantidade: {Math.round(pcpProduct?.previsaoProducao)} {Math.round(pcpProduct?.previsaoProducao) > 1 ? "Caixas" :
                        Math.round(pcpProduct?.previsaoProducao) === 0 ? "Caixas" : "Caixa"}
                    </p>
                  )
                })

                }

              </MainRoundContainer>
            </RoundContainer>
          )
        })

        }

        {/* <RoundContainer>
          <H2RoundContainer>
            RODADA 2
            <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
          </H2RoundContainer>
          <ParagraphRoundContainer>
            Compra de insumos
            <img src="./images/pcp_button.svg" alt="pcp_button" />
          </ParagraphRoundContainer>
          <MainRoundContainer>
            <p>
              <img src="./images/chicken_l.svg" alt="chicken_l" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/chicken_p.svg" alt="chicken_p" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/condiment.svg" alt="condiment" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/carry_bag.svg" alt="carry_bag" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/fries_pcp.svg" alt="fries_pcp" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/box.svg" alt="box" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/pig.svg" alt="pig" />
              Quantidade: 100Kg
            </p>
          </MainRoundContainer>
        </RoundContainer>
        <RoundContainer>
          <H2RoundContainer>
            RODADA 3
            <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
          </H2RoundContainer>
          <ParagraphRoundContainer>
            Compra de insumos
            <img src="./images/pcp_button.svg" alt="pcp_button" />
          </ParagraphRoundContainer>
          <MainRoundContainer>
            <p>
              <img src="./images/chicken_l.svg" alt="chicken_l" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/chicken_p.svg" alt="chicken_p" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/condiment.svg" alt="condiment" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/carry_bag.svg" alt="carry_bag" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/fries_pcp.svg" alt="fries_pcp" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/box.svg" alt="box" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/pig.svg" alt="pig" />
              Quantidade: 100Kg
            </p>
          </MainRoundContainer>
        </RoundContainer>
        <RoundContainer>
          <H2RoundContainer>
            RODADA 4
            <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
          </H2RoundContainer>
          <ParagraphRoundContainer>
            Compra de insumos
            <img src="./images/pcp_button.svg" alt="pcp_button" />
          </ParagraphRoundContainer>
          <MainRoundContainer>
            <p>
              <img src="./images/chicken_l.svg" alt="chicken_l" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/chicken_p.svg" alt="chicken_p" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/condiment.svg" alt="condiment" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/carry_bag.svg" alt="carry_bag" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/fries_pcp.svg" alt="fries_pcp" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/box.svg" alt="box" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/pig.svg" alt="pig" />
              Quantidade: 100Kg
            </p>
          </MainRoundContainer>
        </RoundContainer>
        <RoundContainer>
          <H2RoundContainer className="totalsRound">
            TOTAL DE RODADAS
            <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
          </H2RoundContainer>
          <ParagraphRoundContainer>
            Compra de insumos
            <img src="./images/pcp_button.svg" alt="pcp_button" />
          </ParagraphRoundContainer>
          <MainRoundContainer>
            <p>
              <img src="./images/chicken_l.svg" alt="chicken_l" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/chicken_p.svg" alt="chicken_p" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/condiment.svg" alt="condiment" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/carry_bag.svg" alt="carry_bag" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/fries_pcp.svg" alt="fries_pcp" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/box.svg" alt="box" />
              Quantidade: 100Kg
            </p>
            <p>
              <img src="./images/pig.svg" alt="pig" />
              Quantidade: 100Kg
            </p>
          </MainRoundContainer>
        </RoundContainer> */}
      </SizeContainer>
    </Container>
  );
};
export default WeeklyReportPcp;
